import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://studybuddy.fun';

export default function CanonicalTag() {
  const location = useLocation();

  useEffect(() => {
    // Build canonical URL (strip query params and hash for canonical)
    const canonicalPath = location.pathname;
    const canonicalUrl = `${BASE_URL}${canonicalPath}`;

    // Find or create canonical link
    let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = canonicalUrl;

    return () => {
      // Cleanup not needed - tag persists
    };
  }, [location.pathname]);

  return null;
}
